import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod/v4';

import { SettingsPage } from '@/features/Settings/SettingsPage';
import { canManageOrganizationBilling } from '@/features/organizations/permissions';
import { requireOrganizationRoleRoute } from '@/lib/router-guards';

const settingsSearchSchema = z.object({
    billing: z.enum(['success', 'cancel', 'portal-return']).optional()
});

export const Route = createFileRoute('/_app/settings')({
    beforeLoad: () => requireOrganizationRoleRoute(canManageOrganizationBilling),
    component: SettingsPage,
    validateSearch: (search) => settingsSearchSchema.parse(search)
});
